<template>
  <div id="home_page_map"></div>
</template>
<script>
import Bus from '@/utils/Bus.js'
import echarts from 'echarts'
import geoData from '../map-data/get-geography-value.js'
import allData from '../index.js'
export default {
  name: 'homeMap',
  data() {
    return {
      // dataItem: [],
      // mapRangeList: [] //地图范围区间数据
    }
  },
  props: {
    time: Array,
    dataType: {
      type: Number,
      default: 0
    },
    title: {
      type: Number,
      default: ''
    },
    mapRangeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    year: [String, Number],
    month: [String, Number],
    dataItem: Array
  },
  watch: {
    dataType: function(value, oldValue) {
      this.initData()
    },
    dataItem: function(value, oldValue) {
      if (value.length) {
        this.initData()
      }
    },
    mapRangeList: function(value, oldValue) {
      if (value.length) {
        this.initData()
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    initData() {
      //对数据进行处理
      this.initCanvas(this.title)
    },
    initCanvas(e) {
      //e为true代表是切换时间
      let that = this
      let mapData = {
        title: {
          text: '',
          subtext: ''
        },
        dataRange: {
          x: 'left',
          y: '10px',
          splitList: that.mapRangeList.length && that.mapRangeList,
          color: ['#0B65BC', '#3289DC', '#5FAEF8', '#94CBFF', '#E7E7E7']
        },
        tooltip: {
          borderWidth: 1,
          padding: 10,
          triggerOn: 'mousemove|click',
          showContent: true,
          textStyle: {
            color: '#ffffff'
          },
          formatter: function(params) {
            let data = params.data
            if (data && data.value) {
              let reg = /\d{1,3}(?=(\d{3})+$)/g
              let gl = String(data.value).split('.')
              let n = gl[0].replace(reg, '$&,')
              return `  <div style='font-size:14px;font-weight:500;'>${
                data.name
              }</div><div class="color3">${n}.${gl[1]}</div>    
                                    `
            } else {
              return '暂无数据'
            }
          },
          extraCssText: 'width: 150px'
        },
        series: [
          {
            name: '',
            type: 'map',
            mapType: 'china',
            mapLocation: {
              x: 'left'
            },
            zoom: 1.2,
            selectedMode: 'multiple',
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                areaColor: '#e7e7e7',
                borderColor: '#ffffff'
              },
              emphasis: {
                areaColor: '#00dcbb',
                label: {
                  show: false
                }
              }
            },
            data: []
          }
        ],
        animation: false
      }
      mapData.series[0].data = that.dataItem.length && that.dataItem
      // mapData.title.text = `货运平台${that.title}入网车辆分布-`
      // mapData.title.right = '60%'
      var map = echarts.init(document.getElementById('home_page_map'))
      const chinaJson = require('../map-data/china.json')
      echarts.registerMap('china', chinaJson)
      map.setOption(mapData)
      window.addEventListener('resize', function() {
        map.resize()
      })
    }
  }
}
</script>
<style scoped>
#home_page_map {
  width: calc(100% - 10px);
  height: 100%;
}
</style>
